import { render, staticRenderFns } from "./task_assignment.vue?vue&type=template&id=6c676bc2&scoped=true&"
import script from "./task_assignment.vue?vue&type=script&lang=js&"
export * from "./task_assignment.vue?vue&type=script&lang=js&"
import style0 from "./task_assignment.vue?vue&type=style&index=0&id=6c676bc2&lang=less&scoped=true&"
import style1 from "./task_assignment.vue?vue&type=style&index=1&id=6c676bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c676bc2",
  null
  
)

export default component.exports